import { T } from '../../styles/theme'

export default function BottomSheet({ open, onClose, children }) {
  if (!open) return null
  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 50, display: 'flex', alignItems: 'flex-end' }}
    >
      <div style={{ background: T.card, borderRadius: '24px 24px 0 0', padding: '20px 20px 40px', width: '100%', maxHeight: '85vh', overflowY: 'auto' }}>
        <div style={{ width: 36, height: 4, background: T.cardB, borderRadius: 2, margin: '0 auto 20px' }} />
        {children}
      </div>
    </div>
  )
}
